import React, { useState } from 'react';
import { Play, Info } from 'lucide-react';
import VideoModal from './VideoModal';
import InfoModal from './InfoModal';
import "../styles/Services.css";

const ServiceTag = ({ service }) => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);

  const videos = service.videos || [];
  const hasVideos = videos.length > 0;
  const coverId = hasVideos ? videos[0].id : null;

  return (
    <>
      <article className="service-card card-brand gleam">
        {hasVideos && (
          <button
            type="button"
            className="service-card__media"
            onClick={() => setShowVideoModal(true)}
            aria-label={`Watch ${service.title} videos`}
          >
            <img
              className="service-card__thumb"
              src={`https://img.youtube.com/vi/${coverId}/hqdefault.jpg`}
              alt=""
              loading="lazy"
            />
            <span className="service-card__icon" aria-hidden="true">
              {service.icon}
            </span>
            <span className="service-card__play" aria-hidden="true">
              <Play size={24} fill="currentColor" />
            </span>
            <span className="chip service-card__count">
              {videos.length} {videos.length === 1 ? 'video' : 'videos'}
            </span>
          </button>
        )}

        <div className="service-card__body">
          <h3 className="service-card__title">{service.title}</h3>
          <p className="service-card__text">{service.description}</p>

          <div className="service-card__actions">
            {hasVideos && (
              <button
                type="button"
                className="btn-sun"
                onClick={() => setShowVideoModal(true)}
              >
                <Play size={16} aria-hidden="true" />
                {videos.length === 1 ? 'Watch video' : 'Watch videos'}
              </button>
            )}
            <button
              type="button"
              className="btn-ghost"
              onClick={() => setShowInfoModal(true)}
            >
              <Info size={16} aria-hidden="true" />
              More info
            </button>
          </div>
        </div>
      </article>

      {/* Modales */}
      <VideoModal
        show={showVideoModal}
        handleClose={() => setShowVideoModal(false)}
        videos={videos}
        title={service.title}
      />

      <InfoModal
        show={showInfoModal}
        handleClose={() => setShowInfoModal(false)}
        service={service}
      />
    </>
  );
};

export default ServiceTag;
